import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export function Copy(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M18 7a2 2 0 012 2v10a2 2 0 01-2 2h-8a2 2 0 01-2-2V9a2 2 0 012-2h8zm0 2h-8v10h8V9zM4 15V5a2 2 0 012-2h8a2 2 0 012 2H6v12a2 2 0 01-2-2z" />
    </SvgIcon>
  );
}
